import React from 'react';
import { Form } from 'react-bootstrap';
import * as Icons from '../AllergensIconComponents';

export const ALLERGENS = {
  gluten: { icon: Icons.GlutenIcon, label: 'Glutine', color: '#e31e24' },
  crustacean: { icon: Icons.CrustaceanIcon, label: 'Crostacei', color: '#00a1db' },
  eggs: { icon: Icons.EggIcon, label: 'Uova', color: '#fdb913' },
  fish: { icon: Icons.FishIcon, label: 'Pesce', color: '#00a1db' },
  peanuts: { icon: Icons.PeanutIcon, label: 'Arachidi', color: '#92278f' },
  soya: { icon: Icons.SoyaIcon, label: 'Soia', color: '#00a651' },
  milk: { icon: Icons.MilkIcon, label: 'Lattosio', color: '#f7941d' },
  nuts: { icon: Icons.NutsIcon, label: 'Frutta a guscio', color: '#92278f' },
  celery: { icon: Icons.CeleryIcon, label: 'Sedano', color: '#00a651' },
  mustard: { icon: Icons.MustardIcon, label: 'Senape', color: '#fdb913' },
  sesame: { icon: Icons.SesameIcon, label: 'Sesamo', color: '#f7941d' },
  sulphites: { icon: Icons.SulphiteIcon, label: 'Solfiti', color: '#00a1db' },
  lupin: { icon: Icons.LupinIcon, label: 'Lupini', color: '#92278f' },
  molluscs: { icon: Icons.MolluscIcon, label: 'Molluschi', color: '#00a1db' }
};

const MenuAllergens = ({ selectedAllergens = [], onChange }) => {
  return (
    <div className="mb-3">
      <Form.Label className="fw-bold">Allergeni</Form.Label>
      <div className="d-flex flex-wrap gap-2">
        {Object.entries(ALLERGENS).map(([key, { icon: Icon, label, color }]) => (
          <div 
            key={key}
            className="d-flex flex-column align-items-center"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              const newSelection = selectedAllergens.includes(key)
                ? selectedAllergens.filter(a => a !== key)
                : [...selectedAllergens, key];
              onChange(newSelection);
            }}
          >
            <div style={{
              backgroundColor: '#ffffff',
              padding: '4px',
              borderRadius: '4px',
              boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              <Icon 
                width={40} 
                height={40}
                outerColor={color}
                innerColor="#ffffff"
                style={{
                  opacity: selectedAllergens.includes(key) ? 1 : 0.3,
                  transition: 'opacity 0.2s'
                }}
              />
            </div>
            <small className="text-muted mt-1">{label}</small>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MenuAllergens;